(function () {
    "use strict";

    // @ngInject
    function WorkspacePaymentsControllerCtor($scope, $stateParams, WorkspacesManager, $injector, WorkspaceFileService, Enums, RepositoryService, AppStates) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkspacePaymentsController';

        this.WorkspaceFileService = WorkspaceFileService;
        this.WorkspacesManager = WorkspacesManager;
        this.AppStates = AppStates;

        this.isInWorkspaceView = true;
        this.gotPayments = false;

        var workspaceId = $stateParams.workspace_id;
        var eventId = $stateParams.event_id;

        RepositoryService.persistentPut('event:' + eventId, {tabToOpen: Enums.workspaceTabTypes.payments, latestWsId: workspaceId});

        this.workspace = WorkspacesManager.getWorkspace(workspaceId);
        WorkspacesManager.getPaymentsForWorkspace(this.workspace, workspaceId).then(
            function success(){
                this.gotPayments = true;
            }.bind(this)
        );

        this.analyticsEmptyState = {
            eventName : 'click: create invoice',
            data: {
                type: 'payment empty state',
                unique: 'empty state primary cta'
            }
        };

    }


    Controllers.WorkspacePaymentsController = Class(Controllers.BaseController, {

        constructor: WorkspacePaymentsControllerCtor,
        
        filterFiles: function filterFiles(currFile) {
            return (currFile.isSent() && currFile.hasPayments()) || currFile.hasPaidPayments();
        },

        goToFileView: function goToFileView($event, workspaceFile){
            $event.preventDefault();
            this.WorkspaceFileService.gotoWorkspaceFileView(workspaceFile);
        },

        showDraftWarning: function showDraftWarning(currFile){
            return currFile.isDraftEditable() && !currFile.isFirstDraft() && currFile.isOwnerMode();
        }
    });
}());
